import MysteryBusiness from './mystery_business.json';
import SciFi from './mystery_Scifi.json';
import influence from './influence.json';
import socialvibes from './mystery_socialVibes.json';
import mentalhealth from './mentalhealth.json';
import internetslang from './internet_slang.json';
import traveler from './traveler.json';
import mysteryclothes from './mystery_clothes.json';
import boardgames from './boardgames.json';

export const VocabularyMystery = [
  MysteryBusiness,
  SciFi,
  influence,
  socialvibes,
  mentalhealth,
  internetslang,
  traveler,
  mysteryclothes,
  boardgames,
];